import React, { memo } from 'react';

import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { ComparisonDuplicateSubjectsError } from '../../../studio-blocks/components/error-wrappers/ComparisonDuplicateSubjectsError';
import { ComparisonMetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/ComparisonMetricsErrorWrapper';
import { ComparisonSubjectsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/ComparisonSubjectsErrorWrapper';
import { HistoricalPortfolioSnapshotNotFoundErrorWrapper } from '../../../studio-blocks/components/error-wrappers/HistoricalPortfolioSnapshotNotFoundErrorWrapper';

import { Block } from '../../components/core';
import { PortfolioComparisonContent } from './portfolio-comparison-content';
import { PortfolioComparisonHeader } from './portfolio-comparison-header';

interface PortfolioComparisonBlockProps {
  id: string;
}

export const PortfolioComparisonBlock = memo(function InternalPortfolioComparisonBlock({
  id,
}: PortfolioComparisonBlockProps) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <PortfolioComparisonHeader id={id} />
      </Block.Header>

      <Block.Content
        id={id}
        errorWrappers={[
          ...COMMON_ERROR_WRAPPERS,
          HistoricalPortfolioSnapshotNotFoundErrorWrapper,
          ComparisonSubjectsErrorWrapper,
          ComparisonMetricsErrorWrapper,
          ComparisonDuplicateSubjectsError,
        ]}
      >
        <PortfolioComparisonContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
